import i18next from 'i18next';

export const taxreturnStatesCollection = () => [
  {
    id: 'pending',
    name: i18next.t('common.taxreturn-status.pending')
  },
  {
    id: 'accepted',
    name: i18next.t('common.taxreturn-status.accepted')
  },
  {
    id: 'rejected',
    name: i18next.t('common.taxreturn-status.rejected')
  }
];
